import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/functional_center', [
    {
      path: '',
      name: 'functional-center',
      redirect: { name: 'functional-center-list' },
    },
    {
      path: '/list',
      name: 'functional-center-list',
      component: () =>
        import('@/views/functionalcenter/FunctionalCenterList.vue'),
    },
    {
      path: '/create',
      name: 'functional-center-create',
      component: () =>
        import('@/views/functionalcenter/FunctionalCenterCreate.vue'),
    },
    {
      path: '/:functionalCenterId(\\d+)?',
      name: 'functional-center-edit',
      component: () =>
        import('@/views/functionalcenter/FunctionalCenterEdit.vue'),
    },
  ]);
};
